(function () {
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  ready(function () {
    var upsell = document.querySelector('[data-jet-upsell]');
    if(!upsell) return;

    var kitVariantId = upsell.dataset.kitVariantId;
    var kitAvailable = upsell.dataset.kitAvailable === 'true';
    var checkbox = upsell.querySelector('[data-kit-checkbox]');

    // Find the main product form (Shopify standard: action="/cart/add")
    var form = document.querySelector('form[action^="/cart/add"]');
    if(!form) return;

    form.addEventListener('submit', async function(e){
      if(!checkbox || !checkbox.checked || !kitVariantId || !kitAvailable) return;

      // Let the main product add happen as normal, then add kit immediately after.
      // We prevent default and perform a single cart/add.js call with multiple items where possible.
      e.preventDefault();

      var fd = new FormData(form);
      var mainVariantId = fd.get('id');
      var qty = fd.get('quantity') || 1;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(mainVariantId), quantity: Number(qty) },
              { id: Number(kitVariantId), quantity: 1 }
            ]
          })
        });

        // Redirect to cart (or keep on page if your theme uses a drawer; adjust if needed)
        window.location.href = '/cart';
      } catch(err) {
        // Fallback: submit normal form if something goes wrong
        form.submit();
      }
    });
  });
})();
